<template>
  <div class="icons-preview">
    <router-link class="route-link" to="/app/map">
      <r-icon name="arrow-left" :size="16" />
      <r-text>{{ $t("return") }}</r-text>
    </router-link>
    <div class="icons-preview__controls">
      <div class="icons-preview__colorpicker">
        <r-text>{{ $t("choose-picker") }}</r-text>
        <el-color-picker
          v-model="color"
          class="r-color-picker right-icon"
          size="mini"
          popper-class="r-color-picker-dropdown"
          @active-change="handleColorChange"
          @change="handleColorChange"
        />
      </div>
      <div class="icons-preview__filter">
        <el-input
          size="mini"
          v-model="filter"
          :placeholder="$t('filter-placeholder')"
        />
      </div>
    </div>
    <div class="icons-preview__wrapper">
      <div
        class="icons-preview__item"
        v-for="(item, i) in filteredIcons"
        :key="i"
      >
        <r-icon :name="item" :size="28" :color="color" />
        <r-text>{{ item }}</r-text>
      </div>
    </div>
  </div>
</template>

<script>
import { iconsBank } from "@/components/globals/index";
import debounce from "lodash.debounce";

export default {
  data() {
    return {
      color: "rgb(0, 0, 0)",
      filter: "",
      iconsBank
    };
  },
  computed: {
    filteredIcons() {
      return this.iconsBank.filter(
        e => e.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1
      );
    }
  },
  methods: {
    handleColorChange: debounce(function(val) {
      this.color = val;
    }, 50)
  }
};
</script>

<style lang="scss">
.icons-preview {
  padding: 20px;
  box-sizing: border-box;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: rgba(var(--black), 0.05);
  .route-link {
    display: flex;
    position: absolute;
    height: 30px;
    width: 200px;
    align-items: center;
    color: var(--black);
    .r-icon {
      width: 20px;
      height: 20px;
    }
  }
  &__controls {
    display: flex;
    align-items: center;
    height: 40px;
    justify-content: center;
  }
  &__colorpicker {
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: 16px;
    .r-text {
      margin-right: 8px;
    }
    .r-color-picker {
      width: 200px;
    }
    .el-icon-arrow-down {
      color: var(--black);
    }
  }
  &__wrapper {
    max-height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
  }
  &__item {
    width: 160px;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 8px 8px 0;
    padding: 8px;
    box-sizing: border-box;
    &:last-child {
      margin: 0;
    }
    .r-icon {
      height: 70%;
      filter: drop-shadow(1px 1px 1px rgba(var(--black), 0.25));
    }
    .r-text {
      text-align: center;
      height: 30%;
      overflow: hidden;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "choose-picker": "Цвет иконки",
    "return": "Вернуться",
    "filter-placeholder": "Поиск по имени"
  },
  "en": {
    "choose-picker": "Icon color",
    "return": "Return",
    "filter-placeholder": "Search by name"
  }
}
</i18n>
